import React from 'react'

import { ArtistList } from 'modules/Artists/containers'

import { AdminHeader, Layout } from 'components'

const ArtistsPage = () => (
  <Layout>
    <AdminHeader />
    <ArtistList />
  </Layout>
)

export default ArtistsPage
